var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:{
    appContainer : true,
    flexit: (_vm.$route.name == 'Intro')
  }},[_c('Header'),_c('router-view')],1),(_vm.$route.meta.bottomLayout != 'none')?_c('BottomBar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }